import { kngApi } from 'yxt-biz-pc/packages/api';

export default {
  // 获取知识新目录树
  getKngTreeNew(bodyParams) {
    return kngApi.post('kngCatalog/tree', bodyParams);
  }
};
